module.exports = __webpack_public_path__ + "p7_img2.jpg?6c9774a390c03ddc05509af93133af06";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-imgs/p7/p7_img2.jpg
// module id = 60
// module chunks = 0